import { canv } from "@/canv/global";

export const getEmoteUrl = (src: string) => {
    return `${canv.host}${src}`;
};
